module.exports = "/_next/static/images/4-573b076351bfdadb2c34039d9ac0b5ae.gif";